import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';

import sprite from '../../../../img/sprites.svg';
import { HeadphonesIcon } from '../../../../common/VocabularyButton/VocabularyButton';
import { HOMEWORK_STATE } from './homeworkState';
import LessonVideoTile from './LessonVideoTile';

const LINK_TILES = [
  { key: 'presentation_link', icon: 'monitor', label: 'Презентація' },
  { key: 'google_pdf_url', icon: 'pdf', label: 'PDF' },
  { key: 'youtube_link', icon: 'youtube', label: 'Відео' },
  { key: 'vocabulary_link', icon: 'list', label: 'Словник' },
];

const openLink = (link) => {
  if (link) {
    window.open(link, '_blank', 'noopener');
  }
};

const DoneMark = () => (
  <span className="course-tile__done" title="Домашнє завдання виконано">
    <svg viewBox="0 0 12 12" aria-hidden="true">
      <path d="M2.5 6.3 5 8.6l4.5-5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" style={{ fill: 'none' }} />
    </svg>
  </span>
);

const Tile = ({ label, onClick, className, badge, done, children }) => (
  <button type="button" className={`course-tile ${className}`.trim()} onClick={onClick}>
    {badge && <span className="course-tile__badge">{badge}</span>}
    {!badge && done && <DoneMark />}
    {children}
    <span className="course-tile__label">{label}</span>
  </button>
);

Tile.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  badge: PropTypes.string,
  done: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Tile.defaultProps = {
  className: '',
  badge: '',
  done: false,
};

const SpriteIcon = ({ id }) => (
  <svg className="course-tile__icon" aria-hidden="true"><use href={`${sprite}#${id}`}></use></svg>
);

SpriteIcon.propTypes = { id: PropTypes.string.isRequired };

const MaterialTiles = ({ lesson, onHomework }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const openHomework = () => {
    if (onHomework) {
      onHomework(lesson);

      return;
    }

    localStorage.setItem('event', JSON.stringify(lesson));
    localStorage.setItem('eventId', JSON.stringify(lesson.event_id));
    localStorage.setItem('realHomeworkId', JSON.stringify(lesson.homework_id));
    navigate('/homework', { state: { from: location.pathname } });
  };

  const homework = HOMEWORK_STATE[lesson.homework_icon_color] || HOMEWORK_STATE[1];

  return (
    <div className="course-tiles">
      {LINK_TILES.filter((tile) => lesson[tile.key]).map((tile) => (
        <Tile key={tile.key} label={tile.label} onClick={() => openLink(lesson[tile.key])}>
          <SpriteIcon id={tile.icon} />
        </Tile>
      ))}

      {lesson.vocabulary_token && (
        <Tile
          label="Аудіо"
          onClick={() => navigate('/vocabulary', { state: { w: lesson.vocabulary_token } })}
        >
          <HeadphonesIcon className="course-tile__icon" />
        </Tile>
      )}

      {lesson.video_url && (
        <Tile label="Запис уроку" onClick={() => openLink(lesson.video_url)}>
          <SpriteIcon id="video" />
        </Tile>
      )}

      {lesson.group_video_count > 0 && <LessonVideoTile lesson={lesson} />}

      {lesson.is_show_homework && (
        <Tile
          label="Вправи"
          className={`course-tile--hw course-tile--hw-${homework.tone} ${homework.done ? '' : 'course-tile--pulse'}`}
          badge={lesson.is_show_icon_new ? 'new' : ''}
          done={homework.done}
          onClick={openHomework}
        >
          <SpriteIcon id="book" />
        </Tile>
      )}
    </div>
  );
};

MaterialTiles.propTypes = {
  lesson: PropTypes.object.isRequired,
  onHomework: PropTypes.func,
};

MaterialTiles.defaultProps = {
  onHomework: null,
};

export default MaterialTiles;
